import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getDetailPost } from "../api/getDetailPost";

class DetailContainer extends React.Component {
  componentDidMount() {
    const { id, slug = "" } = this.props;
    this.props.request(id, slug);
  }
  componentWillReceiveProps(nextProps) {
    const { id: nextId, slug: nextSlug } = nextProps;
    console.log("🚀 ~  ~ nextId, nextSlug", nextId, nextSlug);
    const { id, slug } = this.props;
    if (nextId !== id) {
      console.log("🚀 ~  request", nextId);
      this.props.request(nextId, "");
    }
    if (nextSlug !== slug) {
      console.log("🚀 ~  request", nextSlug);
      this.props.request("", nextSlug);
    }
  }
  render = () => {
    const { data, loading, failure, render } = this.props;

    if (failure) {
      return render({ item: {}, date: null, loading: false, failure });
    }
    const result = (data && data.data) || {};
    const date = result && result.date && result.date.toLowerCase() !== "today" ? result.date : null;
    // api response could have posts or post based on query by id or by slug
    const item = (result && result.posts && result.posts[0]) || (result && result.post) || {};
    const notFound = !loading && !item.id;
    return render({ item: notFound ? {} : item, date: notFound ? null : date, loading, failure: notFound });
  };
}

DetailContainer.defaultProps = {};
export default CreateContainer(getDetailPost, DetailContainer);
